// extracted by mini-css-extract-plugin
export default {"external":"a1j1D","card":"b1j1D","active":"c1j1D","content":"d1j1D","buttonContainer":"e1j1D","cardMinHeight":"f1j1D"};